import React, { useState, useEffect } from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Image } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import Form from "react-bootstrap/Form";
import { Link, useParams, useNavigate } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import GI1 from "../../assets/gi-1.svg";
import GI2 from "../../assets/gi-2.svg";
import GI3 from "../../assets/gi-3.svg";
import GI4 from "../../assets/gi-4.svg";
import GI5 from "../../assets/gi-5.svg";
import GI6 from "../../assets/gi-6.svg";
import GI7 from "../../assets/gi-7.svg";
import GI8 from "../../assets/gi-8.svg";
import GI9 from "../../assets/gi-9.svg";
import GI10 from "../../assets/gi-10.svg";
import GI11 from "../../assets/gi-11.svg";
import GI12 from "../../assets/gi-12.svg";
import ginfo from "../../assets/ginfo.svg";
import binfo from "../../assets/binfo.svg";

import sinfo from "../../assets/sinfo.svg";
import SideBar from "../SideBar/SideBar";
import swal from "sweetalert";
import Loader from "../Loader/Loader";
import { BusinessPreviewAPi } from "../API/BusinessListingAPI/BusinessPreview";
import { UpdateStatusApi } from "../API/BusinessListingAPI/UpdateStatus";
import BannerEmpty from "../../assets/others/BannerEmpty.png";
import { toast } from "react-toastify";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.css";
import "froala-editor/js/plugins.pkgd.min.js";
import FroalaEditorView from "react-froala-wysiwyg/FroalaEditorView";
import MobileNumberFormatter from "../../Utils/MobileNumberFormatter";
import BackButton from "../BackButton/BackButton";
import PrivacyTermsConditions from "../PrivacyTermsConditions/PrivacyTermsConditions";

const BusinessPreview = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setdata] = useState([]);
  const [StoreTime, setStoreTime] = useState([]);
  const [AppointmentStatus, setAppointmentStatus] = useState("");
  const [NoData, setNoData] = useState(false);
  const [businessID, setbusinessID] = useState(0);
  const [mobileNumber, setMobileNumber] = useState("");

  const newBannerName =
    data?.business_banner == ""
      ? ""
      : data?.business_name?.length > 35
      ? data?.business_name?.substring(0, 35) + "..."
      : data?.business_name;

  useEffect(() => {
    setLoading(true);
    ApiLoad();
  }, []);

  // const ApiLoad = async () => {
  //   setLoading(true);
  //   const cityId = localStorage.getItem("cityId");

  //   const data = {
  //     mms_city_id: parseInt(cityId),
  //     bu_id: parseInt(slug),
  //   };
  //   const Response = await BusinessPreviewAPi(data, () => {
  //     navigate("/");
  //   });
  //   if (Response === false) {
  //     toast.error("Internal Server Error!", {
  //       position: "top-center",
  //       width: "auto",
  //       autoClose: 1000,
  //       hideProgressBar: true,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "dark",
  //     });
  //     setLoading(false);
  //   } else {
  //     if (Response.success == true) {
  //       setdata(Response.data[0]);
  //       if (Response.data[0].store_timings.length == 0) {
  //         setNoData(true);
  //       } else {
  //         setStoreTime(Response.data[0].store_timings);
  //         setbusinessID(Response.data[0].business_id);
  //       }
  //     }
  //     if (Response.status === 429) {
  //       setLoading(true);
  //       swal({
  //         // title: "Error!",
  //         title: `${Response.message}`,
  //         icon: "error",
  //         buttons: "OK",
  //       });
  //     } else {
  //       swal({
  //         text: `${Response.message}`,
  //         icon: "error",
  //         buttons: "Ok",
  //       });
  //       navigate("/business_listings/all_listings");
  //     }
  //     setLoading(false);
  //   }
  // };

  // -------------------fixed------------------------//
  const ApiLoad = async () => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");

    const data = {
      mms_city_id: parseInt(cityId),
      bu_id: parseInt(slug),
    };
    const Response = await BusinessPreviewAPi(data, () => {
      navigate("/");
    });
    if (Response === false) {
      toast.error("Internal Server Error!", {
        position: "top-center",
        width: "auto",
        autoClose: 1000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else if (Response.status === 429 && Response.success === true) {
      swal({
        title: `${Response.message}`,
        icon: "error",
        buttons: "OK",
      });
      setLoading(false);
    } else if (Response.status === 200 && Response.success === true) {
      setdata(Response?.data[0]);
      setMobileNumber(Response.data[0].contact_num);
      setAppointmentStatus(Response.data[0].appointment_status);
      if (Response.data[0].store_timings.length == 0) {
        setNoData(true);
      } else {
        setStoreTime(Response.data[0].store_timings);
        setbusinessID(Response.data[0].business_id);
      }
      setLoading(false);
    } else {
      swal({
        text: `${Response.message}`,
        icon: "error",
        buttons: "Ok",
      });
      setLoading(false);
      navigate("/business-listings/all-listings");
    }
    setLoading(false);
  };

  // -----end---------------//
  // update status
  const handleChangeDropDown = (e, name) => {
    setLoading(true);
    const cityId = localStorage.getItem("cityId");
    const data = {
      mms_city_id: parseInt(cityId),
      option: "status",
      actionIds: [parseInt(businessID)],
      status_id: parseInt(e.target.value),
    };
    swal({
      title: `Are you sure you want to update status of "${name}"?`,
      icon: "warning",
      buttons: true,
      dangerMode: false,
    }).then(async (willDelete) => {
      if (willDelete) {
        const Response = await UpdateStatusApi(data, () => {
          navigate("/");
        });
        if (Response.status === 429) {
          swal({
            // title: "Success!",
            title: `${Response.message}`,
            icon: "success",
            buttons: "Ok",
          });
        }
        if (Response == false) {
          swal({
            // title: "Success!",
            title: `Internal server error`,
            icon: "success",
            buttons: "Ok",
          });
        } else {
          swal({
            // title: "Success!",
            title: `"${name}" status has been updated successfully!`,
            icon: "success",
            buttons: "Ok",
          }).then((isok) => {
            if (isok) {
              ApiLoad();
            }
          });
        }
      } else {
        setTimeout(() => {
          window.location.reload(false);
        }, 300);
      }
    });
    setLoading(false);
  };

  const allClosed = StoreTime.every(
    (item) =>
      (item.opening_time === "00:00:00" || item.opening_time === "0:00:00") &&
      (item.closing_time === "00:00:00" || item.closing_time === "0:00:00")
  );

  const businessHoursLoop = (StoreTiming) => {
    return (
      <table
        class="opening-hours-table"
        style={{
          paddingBottom: 20,
          marginBottom: 25,
        }}
      >
        {StoreTiming.map((i, k) => {
          const [hourStringO, minuteO] = i.opening_time.split(":");
          const hourO = +hourStringO % 24;
          const OpenTimeVal = (
            (hourO % 12 || 12) +
            ":" +
            minuteO +
            " " +
            (hourO < 12 ? "AM" : "PM")
          ).replace(/^0+/, "");

          // close
          const [hourString, minute] = i.closing_time.split(":");
          const hour = +hourString;
          const CloseTimeVal = (
            (hour % 12 || 12) +
            ":" +
            minute +
            " " +
            (hour < 12 ? "AM" : "PM")
          ).replace(/^0+/, "");

          return (
            <tr key={k}>
              <td className="table_day">{i.day}</td>
              <td className="table_opens">
                {CloseTimeVal === "12:00 AM"
                  ? "Closed"
                  : OpenTimeVal + " - " + CloseTimeVal}
              </td>
            </tr>
          );
        })}
      </table>
    );
  };

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Business Preview</p>
          <p className="text-right orange-text mx-2">
            <div className="orange-text">
              <Image src={binfo} className="mb-1"></Image>{" "}
              <b>{data.business_name}</b>
            </div>
          </p>
          <div
            className="my-3 inner-banner"
            style={{
              backgroundImage:
                data.business_banner == ""
                  ? `url(${BannerEmpty})`
                  : `url(${data.business_banner})`,
            }}
          >
            {/* <p className="banner-title" title={data.business_name}>
              {newBannerName}
            </p> */}
          </div>
          <div>
            <Accordion
              defaultActiveKey={["0"]}
              alwaysOpen
              className="bl-accordian mt-5 BPreview"
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <Image src={ginfo} className="bl-img preview"></Image>General
                  Information
                </Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex">
                    <div className=""></div>
                    <Table className="accordian-table">
                      <tbody>
                        <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI1} className="bl-img mb-1"></Image>
                            Name
                          </td>
                          <td>
                            {data.first_name} {data.last_name}
                          </td>
                        </tr>
                        <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI2} className="bl-img mb-1"></Image>
                            Contact Number
                          </td>
                          <td>{MobileNumberFormatter(mobileNumber)}</td>
                        </tr>
                        <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI3} className="bl-img mb-1"></Image>
                            Email
                          </td>
                          {/* <td>${data.voucher_value}</td> */}
                          <td>{data.email}</td>
                        </tr>
                        <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI4} className="bl-img mb-1"></Image>
                            City
                          </td>
                          <td>{data.city_id == "" ? "-" : data.city_id}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              {/* 2 */}
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <Image src={binfo} className="bl-img preview"></Image>Business
                  Information
                </Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex">
                    <Table className="accordian-table">
                      <tbody>
                        <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI5} className="bl-img mb-1"></Image>
                            Business Name
                          </td>
                          <td>{data.business_name}</td>
                        </tr>
                        <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI6} className="bl-img mb-1"></Image>
                            Business Registration No
                          </td>
                          <td>{data.registration_num}</td>
                        </tr>
                        <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI7} className="bl-img mb-1"></Image>
                            Business Category
                          </td>
                          {/* <td>${data.voucher_value}</td> */}
                          <td>
                            {data.category_name == "" ? "" : data.category_name}
                          </td>
                        </tr>
                        <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI8} className="bl-img mb-1"></Image>No
                            of employees
                          </td>
                          <td>
                            {data.employee_count == ""
                              ? ""
                              : data.employee_count}
                          </td>
                        </tr>
                        {/* <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI9} className="bl-img mb-1"></Image>
                            Address
                          </td>
                          <td>
                            {data.address1 == "" ? "" : data.address1 + ", "}{" "}
                            {data.address2 == "" ? "" : `${data.address2},`}
                            {data.state_name ? data.state_name + ", " : ""}
                            {data.country_name ? data.country_name + ", " : ""}
                            {data.zip_code ? data.zip_code : ""}
                          </td>
                        </tr> */}
                        <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI10} className="bl-img mb-1"></Image>
                            About Business
                          </td>
                          <td>
                            {data.business_about == "" ? (
                              "-"
                            ) : (
                              <FroalaEditorView model={data?.business_about} />
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              {/* 3 */}
              <Accordion.Item eventKey="2">
                <Accordion.Header>
                  <Image src={sinfo} className="bl-img preview"></Image>Store
                  Information
                </Accordion.Header>
                <Accordion.Body>
                  <div className="d-flex">
                    <Table className="accordian-table">
                      <tbody>
                        {/* <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI5} className="bl-img mb-1"></Image>
                            Store Name
                          </td>
                          <td>
                            {data.store_name == "" ? "-" : data.store_name}
                          </td>
                        </tr> */}
                        <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI11} className="bl-img mb-1"></Image>
                            Website
                          </td>
                          <td>
                            {data.website_url !== "" &&
                            data.website_url !== "None" ? (
                              <>
                                <a
                                  target="_blank"
                                  href={
                                    data?.website_url?.startsWith("http")
                                      ? data?.website_url
                                      : `http://${data?.website_url}`
                                  }
                                  className="vouname-blue"
                                >
                                  {data?.website_url}
                                </a>
                              </>
                            ) : (
                              <td>-</td>
                            )}
                          </td>
                        </tr>
                        {/* <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI10} className="bl-img mb-1"></Image>
                            About Store
                          </td>
                          <td>
                            {data.store_desp == "" ? "-" : data.store_desp}
                          </td>
                        </tr> */}
                        <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI12} className="bl-img mb-1"></Image>
                            Opening Hours
                          </td>
                          {NoData ? (
                            <td>-</td>
                          ) : (
                            <div>
                              {/* Both- Appointment and business hour*/}
                              {AppointmentStatus === "True" && !allClosed && (
                                <>
                                  <p className="appintment-text">
                                    We accept clients by appointment only.
                                  </p>
                                  <div>{businessHoursLoop(StoreTime)}</div>
                                </>
                              )}
                              {/* only Business hour */}
                              {AppointmentStatus === "False" && !allClosed && (
                                <div>{businessHoursLoop(StoreTime)}</div>
                              )}

                              {/* only Appointment */}
                              {AppointmentStatus === "True" && allClosed && (
                                <>
                                  <p className="appintment-text">
                                    We accept clients by appointment only.
                                  </p>
                                </>
                              )}
                            </div>
                          )}
                        </tr>
                        <tr>
                          <td
                            width="300px"
                            className="gi-lable"
                            style={{ paddingBottom: 20 }}
                          >
                            <Image src={GI4} className="bl-img mb-1"></Image>
                            Store Locations
                          </td>
                          {data?.store_location?.length > 0 ? (
                            data.store_location.filter(
                              (item) => item.show_address_status === "True"
                            ).length > 0 ? (
                              <>
                                {data.store_location.map((item, index) => (
                                  <>
                                    {item.show_address_status === "True" && (
                                      <td
                                        key={index}
                                        style={{
                                          display: "flex",
                                          flexWrap: "wrap",
                                        }}
                                      >
                                        {item.store_address},&nbsp;
                                        {item.store_city},&nbsp;
                                        {item.state_name},&nbsp;{item.zip_code}
                                      </td>
                                    )}
                                  </>
                                ))}
                              </>
                            ) : (
                              <td>-</td>
                            )
                          ) : (
                            <td>-</td>
                          )}
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
            <p className="width-150 m-auto">
              <Form.Select
                aria-label="Default select example"
                className="table-select status_select"
                onChange={(e) => handleChangeDropDown(e, data.business_name)}
              >
                {data?.status?.map((i, k) => {
                  return (
                    <option
                      value={i.business_status_id}
                      selected={
                        data.status_id === i.business_status_id
                          ? "selected"
                          : ""
                      }
                    >
                      {i.business_status}
                    </option>
                  );
                })}
              </Form.Select>
            </p>
          </div>
        </div>
      </div>
      <PrivacyTermsConditions />
    </>
  );
};

export default BusinessPreview;
